<template>
  <div>
    <div id="login-container">
      <div class="container">
        <div id="login-name" class="row d-flex justify-content-center text-center mt-5">
          <img class="logo-img" src="../../assets/img/logo.svg" alt="ACM Destiny Logo"> <img class="logo-title-img" src="../../assets/img/logo-title-06.png" alt="ACM Destiny">
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-md-6" id="login">
            <form @submit.prevent="" autocomplete="off">
              <div class="form-group">
                <label class="user">Username or Email </label>
                <ws-text-input v-model="username" name="username" field="username" :focused="true" :lightMode="true"/>
              </div>

              <div class="form-group">
                <label class="user">Password </label>
                <ws-text-input type="password" v-model="password" name="password" field="password" :lightMode="true"/>
              </div>

              <div class="form-group">
              </div>

              <div class="row">
                <div class="col-xl-4">
                  <ws-signal-button id="login-btn" class="btn btn-primary mt-2" text="Login" :onSubmit="handleSubmit" />
                </div>
                <div class="col-xl-8">
                  <p class="login-links">
                    <small style="color: white">
                      <a href="#" style="color: white" @click="showSupportRequest"> Need Help? </a> |
                      <a href="#" style="color: white" @click="showPasswordRequest"> Lost Password? </a>
                    </small>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <p class="copyright mt-2">
            <small>&copy; {{ copyright }}</small>
          </p>
        </div>
      </div>
    </div>
    <ws-login-support-request v-if="showSupport"></ws-login-support-request>
    <ws-login-password-request v-if="showPassRequest"></ws-login-password-request>
    <ws-login-password-reset v-if="showPasswordReset"></ws-login-password-reset>
  </div>
</template>

<script>
import WsLoginSupportRequest from '@/views/support/LoginSupportRequest'
import WsLoginPasswordRequest from '@/views/support/LoginPasswordRequest'
import WsLoginPasswordReset from '@/views/support/LoginPasswordReset'
import { AUTH_LOGIN } from '@/store/auth/auth.types'
import { API_SET_POSTED } from '@/store/api/postStatus.types'

export default {
  name: 'Login',

  data () {
    return {
      username: '',
      password: '',
      showSupport: false,
      showPassRequest: false,
      showPasswordReset: false,
      errorCodes: [401, 403, 404, 425, 419, 422, 429, 499, 500]
    }
  },

  created () {
    this.$on('closeLoginSupportRequest', () => {
      this.showSupport = false
    })

    this.$on('closeLoginPasswordRequest', () => {
      this.showPassRequest = false
    })

    this.$on('closeLoginPasswordReset', () => {
      this.showPasswordReset = false
    })
  },

  mounted () {
  },

  watch: {
    $route () {
      if (this.isPasswordResetLink()) {
        this.$store.commit(API_SET_POSTED, false)
        this.showPasswordReset = true
      }
    }
  },

  methods: {
    handleSubmit () {
      this.$store.dispatch(AUTH_LOGIN, {
        username: this.username,
        password: this.password
      }).then(() => {
        this.$router.push({ name: 'home' })
      })
    },

    showSupportRequest () {
      this.$store.commit(API_SET_POSTED, false)
      this.showSupport = true
    },

    showPasswordRequest () {
      this.$store.commit(API_SET_POSTED, false)
      this.showPassRequest = true
    },

    isPasswordResetLink () {
      return this.$route.name === 'user-password-reset' &&
        typeof this.$route.query.email !== 'undefined' &&
        typeof this.$route.query.token !== 'undefined'
    }
  },

  computed: {
    copyright () {
      return process.env.COPYRIGHT
    },

    appName () {
      return process.env.APP_NAME
    }
  },

  components: {
    WsLoginSupportRequest,
    WsLoginPasswordRequest,
    WsLoginPasswordReset
  }
}
</script>

<style lang="scss" scoped>
  @import "~sass-material-colors/sass/sass-material-colors";

  #login-container {
    position: fixed;
    top: 0;
    left: 0;

    /* Preserve aspect ratio */
    min-width: 100%;
    min-height: 100%;

    background-image: url(../../assets/img/backdrop-01.jpg);
    background-repeat: no-repeat;
    background-size: cover;
  }

  #login-name {
    font-size: 4.4rem;
    color: white;
    font-weight: 700;
  }

  #login {
    background-color: rgba(13, 13, 13, 0.4);
    min-height: 300px;
    padding: 40px 80px 40px 80px;
  }

  .user {
    color: white;
  }

  .login-links {
    margin-top: 0.5rem;
  }

  .logo-img {
    width: 70px;
    height: 70px;
    // margin-top: 20px;
    margin-right: 15px;
    border-radius: 3px;
    margin-bottom: 20px;
  }

  .logo-title-img {
    // width: 299px;
    height: 70px;
    margin-bottom: 20px;
    // margin-top: 20px;
    // margin-right: 15px;
    // border-radius: 3px;
    // background-color: #009bff;
    padding: 5px 10px 5px 10px;
    border-radius: 3px;
  }

  .copyright {
    font-size: 1rem;
    color: white;
    background-color: rgba(13, 13, 13, 0.4);
    padding: 3px 10px 3px 10px;
  }

  label {
    font-weight: normal;
  }

  @media (min-width: 1200px) {
    .login-links {
      text-align: right;
    }
  }

  .is-invalid {
    background-color: material-color('orange', '500') !important;
    border-color: material-color('orange', '500') !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue